import React, { useState } from "react";
import axios from "../Axiosinstance";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  TableContainer,
  Typography,
  TextField,
  Button,
  Box, TablePagination
} from "@mui/material";
import Header from "./Header"
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
// import Typography from '@mui/material/Typography';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';

const StudentSubmissions = () => {
  const [studentId, setStudentId] = useState("");
  const [submissions, setSubmissions] = useState([]);
  const [data, setData] = useState([]);
  const [fectched, setFetched] = useState(false);

  const handleSearch = async () => {
    try {
      const response = await axios.get(`/submissions/student/custom/${studentId}`);
      setSubmissions(response.data.combained);
      setData(response.data)
      setFetched(true);
      console.log("response", response.data);
    } catch (error) {
      console.error("Error fetching submissions:", error);
    }
  };


  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5); // you can set default rows per page here

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // reset to first page when rows per page changes
  };

  // const paginatedData = submissions.slice(
  //   page * rowsPerPage,
  //   page * rowsPerPage + rowsPerPage
  // );
  // console.log("paginatedData", paginatedData);

  const moduleDetailsMap = data?.intakeDetails?.moduleDetails?.reduce((map, module) => {
    map[module.id] = module.moduleName;
    return map;
  }, {}) || {};

  const totalModules = Object.keys(moduleDetailsMap).length;

  const getModuleName = (startModulus) => {
    const adjustedId = ((startModulus - 1 + totalModules) % totalModules) + 1;
    return moduleDetailsMap[adjustedId] || `Unknown Module (ID: ${adjustedId})`;
  };


  const getStatusAndColor = (startDate, endDate) => {
    const now = new Date();
    const start = new Date(startDate);
    const end = new Date(endDate);

    if (now >= start && now <= end) {
      return { status: 'In Progress', color: '#e3f2fd' }; // Blue
    } else if (now > end) {
      return { status: 'Completed', color: '#e8f5e9' }; // Green
    } else {
      return { status: 'Not Started', color: '#ffebee' }; // Red
    }
  };



  return (
    <>
      <Header />
      <Box
        sx={{
          width: { xs: '100%', sm: '95%', md: '90%', lg: '85%', xl: '80%' }, // responsive widths
          mx: 'auto',  // center horizontally
          p: 2,        // padding
          borderRadius: 2,      // rounded corners
        }}
      >
        <Typography
          variant="h4"
          fontWeight="bold"
          gutterBottom
          sx={{
            color: "primary.main",
            textDecoration: "underline",
            textUnderlineOffset: "6px",
            letterSpacing: "1px",
            textAlign: "center",
            mt: 3,
            mb: 4,
            fontSize: "2rem",
          }}
        >
          Student Submissions
        </Typography>
        <Box
          display="flex"
          alignContent="flex-start"
          gap={2}
          mb={2}
          sx={{
            width: { xs: '100%', sm: '80%', md: '70%', lg: '60%' },

          }}
        >
          <TextField
            label="Enter Student NRIC"
            variant="outlined"
            size="small"
            value={studentId}
            onChange={(e) => setStudentId(e.target.value)}
            fullWidth
          />
          <Button variant="contained" onClick={handleSearch}>
            Search
          </Button>
        </Box>



        <Paper>

          {data.intakeDetails?.scheduleDateDetails.length > 0 ? (
            data?.intakeDetails?.scheduleDateDetails?.map((item) => (
              <Accordion key={item.id}>
                <AccordionSummary
                  expandIcon={<ArrowDropDownIcon />}
                  aria-controls={`panel-${item.id}-content`}
                  id={`panel-${item.id}-header`}
                  sx={{
                    backgroundColor: getStatusAndColor(item.startDate, item.endDate).color,
                  }}
                >
                  <Box display="flex" justifyContent="space-between" alignItems="center" width="100%">
                    <Typography component="span">
                      <b>Module Name:</b> {getModuleName(item.startModulus)}
                    </Typography>
                    <Chip
                      label={getStatusAndColor(item.startDate, item.endDate).status}
                      variant="outlined"
                    />
                  </Box>
                </AccordionSummary>
                <AccordionDetails>
                  <TableContainer>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell style={{ fontWeight: 'bold' }}>Description</TableCell>
                          <TableCell style={{ fontWeight: 'bold' }}>Submitted At</TableCell>
                          <TableCell style={{ fontWeight: 'bold' }}>Grade</TableCell>
                          <TableCell style={{ fontWeight: 'bold' }}>Comments</TableCell>
                          <TableCell style={{ fontWeight: 'bold' }}>Approver</TableCell>
                          <TableCell style={{ fontWeight: 'bold' }}>Approved At</TableCell>
                          <TableCell style={{ fontWeight: 'bold' }}>Download</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {submissions.filter((submission) => submission.moduleName === getModuleName(item.startModulus))
                          .map((submission) => (
                            <TableRow key={submission.id}>
                              <TableCell>{submission.description}</TableCell>
                              <TableCell>
                                {submission.submittedAt ? new Date(submission.submittedAt).toLocaleString() : 'Pending'}
                              </TableCell>
                              <TableCell>{submission.grade}</TableCell>
                              <TableCell>{submission.comments}</TableCell>
                              <TableCell>{submission.approver}</TableCell>
                              <TableCell>
                                {submission.approvedAt
                                  ? new Date(submission.approvedAt).toLocaleString()
                                  : 'Pending'}
                              </TableCell>
                              <TableCell>
                                <a
                                  href={submission.submissionUrl}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  View PDF
                                </a>
                              </TableCell>
                            </TableRow>
                          ))}
                        {submissions.filter((submission) => submission.moduleName === getModuleName(item.startModulus)).length === 0 && (
                          <TableRow>
                            <TableCell colSpan={7} align="center">
                              No submissions found.
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>

                </AccordionDetails>
              </Accordion>

            ))) : (
            <Typography align="center" sx={{ p: 2 }}>
              No submissions found.
            </Typography>
          )}
        </Paper>
      </Box >
    </>
  );
};

export default StudentSubmissions;
